/* import __COLOCATED_TEMPLATE__ from './edit-project-title.hbs'; */
import { resolve } from 'rsvp';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { closeModal } from "sh-www/utils/modal-controls";

/** @module */
const EditProjectTitleModalComponent = Component.extend({
  /** @inheritDoc */
  tagName: '',

  /** @type {Ember.Service} */
  applicationCommandService : service('commands/application-commands'),

  /** @inheritDoc */
  actions: {
    /**
     * @param {string} title
     * @returns {Promise<void>}
     */
    save(title) {
      if (title === this.get('model.application.title')) {
        return resolve().then(() => {
          closeModal(this);
        });
      }

      return this.get('applicationCommandService').updateApplicationTitle(this.get('model.application.id'), title).then(() => {
        closeModal(this);
      });
    },

    /**
     *
     */
    cancel() {
      closeModal(this);
    },
  },
});

export default EditProjectTitleModalComponent;
